import React from "react"
import { UsersClient, ForgotPasswordRequest } from "../../generated";
import { RouteComponentProps } from "react-router-dom";
import * as Yup from "yup";

import { Forms } from "../../common/components/CmForms"
import { links } from "../../routes";

const { Form, Submit, FormText } = Forms<{ email: string }>();

interface State {
    error: string,
    resultOk: boolean | undefined,
}
export default class ForgotPassword extends React.Component<RouteComponentProps, State>
{
    constructor(props: RouteComponentProps) {
        super(props);
        this.state = {
            error: "",
            resultOk: undefined,
        }
    }

    private createFullHref(path: string) {
        return window.location.origin.concat(this.props.history.createHref({ pathname: path }));
    }

    private requestReset = (e: { email: string }) => {
        new UsersClient().forgotPassword(new ForgotPasswordRequest({ email: e.email, resetPasswordPage: this.createFullHref(links.resetPassword) }))
            .then(resultOk => this.setState({ resultOk }));
    }

    render() {
        return (
            <div className="container">
                <div className="card card-outline-info">
                    <div className="card-header text-white">Password dimenticata</div>
                    <div className="card-body">

                        <Form
                            initialValues={{ email: "" }}
                            onSubmit={this.requestReset}
                            validationSchema={Yup.object<{ email: string }>({
                                email: Yup
                                    .string()
                                    .email("L'email inserita non è valida")
                                    .required('Campo obbligatorio'),
                            })}
                        >

                            <div className="container">
                                <div className="ibox gray-bg box-shadow">
                                    <div className="ibox-title">
                                        <h3>Reset Password</h3>
                                    </div>
                                    <div className="ibox-content">
                                        <p>Inserisci l'email con cui ti sei registrato, e ti invieremo il necessario per creare una nuova password</p>
                                        <FormText
                                            label="Email"
                                            name="email"
                                        />
                                        <p style={{ display: this.state.resultOk !== undefined ? "" : "none" }}
                                            className={this.state.resultOk !== undefined && this.state.resultOk ? "alert alert-success voffset4" : "alert alert-warning voffset4"}
                                            role="alert">{this.state.resultOk
                                                ? "Abbiamo inviato al tuo indirizzo una email contenente il link per effettuare il reset della password"
                                                : "Non è stato possibile effettuare il reset della password in quanto ci sono problemi con l'account. Contattare l'assistenza."}
                                        </p>
                                        <Submit alwaysActive>Reimposta la password</Submit>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}